import TabNav from "common/components/TabNav"
import FacturasEnviadas from "features/Documentos/pages/Facturas/FacturasEnviadas"
import FacturasRecibidas from "features/Documentos/pages/Facturas/FacturasRecibidas"
import { documentosSelector } from "features/Documentos/redux/documentosSlice"
import { useSelector } from "hooks/useSelector"
import { nanoid } from "nanoid"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { TAB_DOCUMENTOS_RECIBIDOS } from "../../constants"
import { facturasColumns } from "../../constants/facturasColumns"
import DocumentoColumnsProvider from "../../context/DocumentoColumnsContext"

const Facturas = () => {
  const { t } = useTranslation()

  const onRenderTabs = useMemo(() => {
    return [
      {
        key: nanoid(),
        header: `${t("crear.factura.saleLabel")}`,
        component: () => FacturasEnviadas(),
        id: 0,
      },
      {
        key: TAB_DOCUMENTOS_RECIBIDOS,
        header: `${t("crear.factura.buyLabel")}`,
        component: () => FacturasRecibidas(),
        id: 1,
      },
    ]
  }, [t])

  const [tabSelected, setTabSelected] = useState(0)

  const [tabs, setTabs] = useState(onRenderTabs)
  const { documentosPendientes } = useSelector(documentosSelector)

  useEffect(() => {
    setTabs(onRenderTabs)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  useEffect(() => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.key === TAB_DOCUMENTOS_RECIBIDOS
          ? {
              ...tab,
              quantity: documentosPendientes,
            }
          : tab
      )
    )
  }, [documentosPendientes])

  return (
    <DocumentoColumnsProvider columns={facturasColumns(tabSelected, t)}>
      <div className='tw-bg-white tw-rounded-xl tw-min-w-fit tw-shadow !tw-h-full tw-overflow-hidden'>
        <div className='tw-py-4 tw-px-8 mobile:tw-flex tw-justify-between tw-flex-col tw-items-start sm:tw-items-center sm:tw-flex-row tw-hidden'>
          <TabNav
            tabs={tabs}
            active={tabSelected}
            setActive={setTabSelected}
          />
        </div>
        {onRenderTabs.map((tab) =>
          tab.id === tabSelected ? <tab.component key={tab.id} /> : null
        )}
      </div>
    </DocumentoColumnsProvider>
  )
}

export default Facturas
